import type { Speaker } from "src/types";

export const DEFAULT_SPEAKERS: Speaker[] = [
  {
    id: 1,
    name: "Marwah Cherry",
    first_name: "Marwah",
    last_name: "Cherry",
    headline: "CEO, Acme Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-1.9e201140.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 2,
    name: "Isabella Ferghal",
    first_name: "Eduard",
    last_name: "Sustainable Ops Manager, Globex",
    headline: "Sustainable Ops Manager, Globex",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-2.fef53595.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 3,
    name: "Clifford Carey",
    first_name: "Clifford",
    last_name: "Carey",
    headline: "Founder, Consult",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-3.728e886e.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 4,
    name: "Farraz Gale",
    first_name: "Farraz",
    last_name: "Gale",
    headline: "Advocacy Strategy Manager, ACME Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-4.3d39a13f.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 5,
    name: "Andrea Orlando",
    first_name: "Andrea",
    last_name: "Orlando",
    headline: "Global sustainability manager, Zikakabo",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-5.f97f7a4e.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 6,
    name: "Nayla O’Moore",
    first_name: "Nayla",
    last_name: "O’Moore",
    headline: "CEO, Venchi",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-6.8cf9d4c8.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 7,
    name: "Aleksandra Walsh",
    first_name: "Aleksandra",
    last_name: "Walsh",
    headline: "Senior Manager, Logistics, ACME Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-7.ea7e81af.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 8,
    name: "Eduard Bauer",
    first_name: "Eduard",
    last_name: "Bauer",
    headline: "Head of business development, Venchi",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/seldon/images/headshot-8.10c1930e.png",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
];
